import Enum from '@square/dashboard-utilities/utils/enum';
import { ProtoBaseModel, repeated, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import Instrument from '@square/dashboard-data/models/squareup/simple-instrument-store/api/instrument';
import InstrumentSummary from '@square/dashboard-data/models/squareup/simple-instrument-store/api/instrument-summary';
export const Status = new Enum(['INVALID_STATUS', 'SUCCESS']);
export default ProtoBaseModel.extend({
  instrument: repeated(Instrument),
  instrumentSummary: repeated(InstrumentSummary),
  status: attr(Status)
}).reopenClass({
  Status
});